export const SessionCategoryIconsBasePath = '/assets/svg/session-category-icons';